import { render, staticRenderFns } from "./ChatRecord.vue?vue&type=template&id=3bd70ec4&scoped=true"
import script from "./ChatRecord.vue?vue&type=script&lang=js"
export * from "./ChatRecord.vue?vue&type=script&lang=js"
import style0 from "./ChatRecord.vue?vue&type=style&index=0&id=3bd70ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd70ec4",
  null
  
)

export default component.exports